export const themeSpacing = {
  s: '4px',
  m: '8px',
  '2m': '12px',
  l: '16px',
  xl: '24px',
  '2xl': '32px',
  '3xl': '40px',
  '4xl': '64px'
};
